import * as yup from 'yup';

const onboardCategoryModalFormValidation = yup.object().shape({
  name: yup.string().trim().required('Category name is a required field'),

});
export default onboardCategoryModalFormValidation;
